import { z } from 'zod'

import { CONTRACT_TYPES } from '@/pages/instruments/new-instrument/constants/contract-types'

export const contractTypeSchema = z.enum(CONTRACT_TYPES)
